import { render } from "./PpmProjectDialog.vue?vue&type=template&id=5d54157d&scoped=true"
import script from "./PpmProjectDialog.vue?vue&type=script&lang=js"
export * from "./PpmProjectDialog.vue?vue&type=script&lang=js"

import "./PpmProjectDialog.vue?vue&type=style&index=0&id=5d54157d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d54157d"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QInput,QIcon,QSeparator,QLinearProgress,QItem,QItemSection,QItemLabel});qInstall(script, 'directives', {Ripple});
